export default __webpack_public_path__ + "static/media/filter.6c146a94.gif";